import { secondAxios } from "../../../../api/axios";

export const onSendBomToPlm = async (projectId) => {
  try {
    const data = await window.electron?.freecad.getBOM();

    // console.log("BOM data from model: ", data?.bom);

    // const drawingBoms = data?.bom.map((d) => {
    //   if (d?.name) {
    //     const drawing = {
    //       ...d,
    //       projectId,
    //       source: "Freecad",

    //       materials: d.materials.map((m) => {
    //         return {
    //           ...m,
    //           description: m.Description,
    //           unit: m.Unit,
    //           quantity: m.Qty,
    //           weightlb: m["Weight (lb)"],
    //         };
    //       }),
    //     };

    //     return drawing;
    //   } else {
    //     alert("Something went wrong, open freecad");
    //     return false;
    //   }
    // });

    const drawingBoms = data?.bom.map((d) => {
      if (d?.name) {
        const drawing = {
          ...d,
          projectId,
          source: "Inventor",

          materials: d.materials.map((m) => {
            return {
              ...m,
              unit: m.Unit || m.unit,
              quantity: m.Qty || m.quantity || m.Quantity,
              description: m.description || m.Description,
            };
          }),
        };

        return drawing;
      } else {
        alert("Something went wrong, open freecad");
        return false;
      }
    });
    console.log("drawingBoms", drawingBoms);
    const res = await secondAxios.post("/drawing", drawingBoms);
    console.log("res", res);
    const resData = res?.data;

    // const url = `http://localhost:3001/projects/${projectId}/equipments/main_tank#main-nav=MCS&mcs-tab=Drawing%20BOM`;
    const url = `https://demo.chinookdt.com/projects/${projectId}/equipments/main_tank#main-nav=MCS&mcs-tab=Drawing%20BOM`;

    if (resData?.isExisted) {
      const link =
        url + `&drawing-id=${resData?.existedDrawing?.id}&validate=true`;

      // window.electron.openExternal(link);
      return {
        state: "info",
        // link,
        msg: "Drawing Revision is already existed in PLM, Check it in PLM Database.",
      };
    } else if (resData?.[0]?.id) {
      const link = url + `&drawing-id=${resData?.[0]?.id}&validate=true`;

      // window.electron.openExternal(link);
      return {
        state: "success",
        // link,
        msg: "Drawing is sent to the PLM successfully, Please check it in MCS/Drawing BOM.",
      };
    } else {
      return {
        state: "error",
        msg: "something went wrong, Please check the Freecad Drawing bom and retry.",
      };
    }
  } catch (error) {
    console.log("BOM data from model: Wrong");
    return {
      state: "error",
      msg: "something went wrong, Please check the Freecad Drawing bom and retry.",
    };
  }
};
